import { formatToLocalDate } from '../../../../../utils/dateFormatter';

/**
 * Generates a unique unicode identifier for new AZK stations
 * Creates a random alphanumeric string prefixed with 'AZK'
 * 
 * @returns A unique unicode string in format 'AZK' + random characters
 */
export const generateUnicode = (): string => {
  return 'AZK' + Math.random().toString(36).substr(2, 9).toUpperCase();
};

/**
 * Formats date values for display in the profile interface
 * Handles Date objects, ISO strings, and undefined values
 * 
 * @param date - Date value to format (Date object, string, or undefined)
 * @returns Formatted date string in Ukrainian locale or '-' if no date
 */
export const formatDate = (date: string | Date | undefined): string => {
  if (!date) return '-';
  if (date instanceof Date) {
    return date.toLocaleDateString('uk-UA');
  }
  return formatToLocalDate(date);
};

/**
 * Checks if a station brand indicates it's an OKKO station
 * Performs case-insensitive comparison for both Ukrainian and English variants
 * 
 * @param brand - Brand name to check (can be undefined)
 * @returns True if brand is OKKO (in any case/language variant), false otherwise
 */
export const isOkkoStationCheck = (brand: string | undefined): boolean => {
  return brand?.toUpperCase() === 'ОККО' || brand?.toUpperCase() === 'OKKO' || false;
};
